<template>
  <div>
    <TableMain
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      @reload="$refs.header.query()"
    >
      <TableHeader ref="header" slot="header" @query="getData" />
    </TableMain>
  </div>
</template>
<script>
import TableMain from './main'
import TableHeader from './header.vue'
export default {
  components: { TableMain, TableHeader },
  props: { orderCode: { type: String, default: '' } },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  methods: {
    getData(form) {
      if (!this.orderCode) return
      this.loading = true
      this.$api
        .pendingOrderTechDocListApi({ orderCode: this.orderCode, ...form })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
